// this exists so we do not have to duplicate initialization logic between storybook, jest, and our main app
import VueClipboard from 'vue-clipboard2';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import Buefy from 'buefy';

import { lsFilters } from 'ls-vue-common';
import { timestamp } from '@/filters';

Vue.use(Buefy);
Vue.use(VueClipboard);
Vue.use(VTooltip, {
    popover: {
        defaultTrigger: 'hover focus',
        defaultPlacement: 'top-end',
    },
});

Vue.filter('currency', lsFilters.templateFilters.currency);
Vue.filter('date', lsFilters.templateFilters.date);
Vue.filter('formattedPhone', lsFilters.templateFilters.formattedPhone);
Vue.filter('frequency', lsFilters.templateFilters.frequency);
Vue.filter('fullName', lsFilters.templateFilters.fullName);
Vue.filter('titleCase', lsFilters.templateFilters.titleCase);
Vue.filter('timestamp', timestamp);
